
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { NotificationType } from '@alao-frontend/ui/src/types/notification'

@Component
export default class PartnerPromoAction extends Vue {
  @Prop({ type: String, required: true })
  readonly promocode!: string

  copyToClipboard (): void {
    navigator.clipboard.writeText(this.promocode).then(() => {
      this.$notify({
        title: this.$t('offerCard.share.clipboardTitle') as string,
        message: this.$t('partner.exclusivePromo.successMessage') as string,
        duration: 3000,
        type: NotificationType.SUCCESS,
      })

      this.$emit('copy')
    })
  }
}
